
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function TempoTravelleronrentinpune() {



  const cardData =
  {
    keyword: ' Tempo Traveller On Rent in Pune',
    heading: 'Vaishnavi Travels: Tempo Traveller On Rent in Pune',
    headingDescription: 'Vaishnavi Travels offers affordable and reliable Tempo Traveller on Rent in Pune, ideal for weddings, corporate outings, school trips, pilgrimages, and family tours. Our Tempo Travellers are well-maintained with spacious push-back seats, powerful air-conditioning, and ample luggage space, ensuring a smooth and comfortable journey for medium to large groups. With experienced chauffeurs, punctual pickups, and flexible booking options, we make group travel simple and stress-free. Whether it’s a short city ride, religious yatra, weekend picnic, or long outstation tour, Vaishnavi Travels guarantees safe, convenient, and comfortable Tempo Traveller rental services in Pune.',

    top: 'Top Places to Visit in Pune with Vaishnavi Travels',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732, is Pune’s most iconic fort palace and the former seat of the Peshwas. The grand gateways, sprawling gardens, and historic ruins narrate tales of Maratha pride and valor. Though partially destroyed by fire in 1828, the fort still draws thousands of visitors. The evening light-and-sound show revives the story of Bajirao and Mastani with dramatic effects. Tourists love exploring its courtyards and fountains. Shaniwar Wada is Pune’s crown jewel of heritage and culture."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, built in 1892, is a majestic monument linked with India’s freedom struggle. It was the place of imprisonment for Mahatma Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. Today, it houses a museum displaying Gandhi’s personal items, photographs, and letters. The palace’s Italian arches and sprawling gardens add architectural elegance. Visitors enjoy peaceful strolls here while reflecting on history. Aga Khan Palace is Pune’s inspirational symbol of sacrifice and patriotism."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is famous for the 1670 battle where Tanaji Malusare fought valiantly for Chhatrapati Shivaji Maharaj. The fort offers trekking trails and panoramic views of the Sahyadris. Visitors explore bastions, memorials, and temples that echo Maratha bravery. During monsoon, mist and waterfalls make it even more scenic. Local villagers serve rustic pithla-bhakri to hungry trekkers. Sinhagad is Pune’s adventure and history-packed escape."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most famous shrine dedicated to Lord Ganesha. Established over 125 years ago, it features a grand idol decorated with gold and ornaments. During Ganesh Chaturthi, the temple becomes the epicenter of festivities attracting lakhs of devotees. Known for its charitable initiatives, it is both a religious and cultural landmark. The spiritual energy here uplifts visitors instantly. Dagdusheth Temple is Pune’s divine and cultural heartbeat."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "The Pataleshwar Cave Temple, carved in the 8th century, is an ancient rock-cut shrine dedicated to Lord Shiva. Massive stone pillars, a sanctum, and a Nandi mandapa highlight its architectural brilliance. Despite being in the city center, it offers a calm and meditative retreat. Evening prayers and chants enhance the spiritual vibe. The temple is admired for its simplicity and craftsmanship. Pataleshwar is Pune’s hidden gem of spirituality and history."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum is a cultural treasure housing over 20,000 artifacts collected by Dr. Dinkar Kelkar. The exhibits include ornaments, musical instruments, sculptures, and antiques of daily life. The recreated Mastani Mahal is a highlight showcasing Maratha romance and heritage. Students and tourists find the museum educational and fascinating. It preserves centuries of traditions under one roof. Raja Dinkar Kelkar Museum is Pune’s proud showcase of art and culture."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers a panoramic view of the city. At the top stands the Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Smaller shrines and a museum add to its cultural richness. Pilgrims climb 103 steps to reach the temple, combining devotion with scenic charm. Sunrise and sunset views from here are breathtaking. Parvati Hill is Pune’s sacred and serene retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global hub of spirituality and wellness. Spread across lush gardens, it attracts seekers from around the world. The ashram offers meditation techniques, yoga, and personal growth workshops. Japanese Zen gardens and peaceful meditation halls enhance the experience. It is not just a spiritual center but also a rejuvenation retreat. Osho Ashram is Pune’s international destination for peace and mindfulness."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, also called Okayama Friendship Garden, is Pune’s largest landscaped park inspired by Japan’s Korakuen Garden. It features flowing streams, stone bridges, and manicured lawns. Families love visiting for picnics, photography, and evening walks. The garden symbolizes Indo-Japanese cultural friendship. Seasonal flowers and green landscapes attract nature lovers year-round. Pu La Deshpande Garden is Pune’s green paradise of tranquility."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, located on the Mutha River, is a popular weekend retreat for Puneites. It supplies water to the city while offering scenic views of hills and flowing waters. In monsoon, the overflowing dam creates mesmerizing sights. Families enjoy roadside snacks like roasted corn and hot tea by the banks. It also serves as the gateway to Sinhagad Fort nearby. Khadakwasla Dam is Pune’s natural and refreshing escape."
  }
],


     "services": [
    {
      "name": "Pune Tempo Traveller Hire",
      "description": "Rent a reliable Tempo Traveller in Pune, perfect for group travel across the city or outstation trips. Our well-maintained vehicles ensure comfortable seating, ample luggage space, and smooth rides for family outings, corporate events, and more."
    },
    {
      "name": "13/17 Seater Tempo Car Rental",
      "description": "Choose between 13 and 17 seater Tempo Travellers to suit your group size. These spacious vehicles come equipped with comfortable seats, proper ventilation, and safety features for an enjoyable journey."
    },
    {
      "name": "AC Tempo Traveller Pune",
      "description": "Travel in cool comfort with our air-conditioned Tempo Travellers in Pune. Ideal for summer trips and long-distance travel, our AC vehicles ensure a pleasant environment regardless of the weather."
    },
    {
      "name": "Non AC Tempo Hire Pune",
      "description": "Affordable non-AC Tempo Traveller options available for budget-conscious travelers who still want quality and reliability. These vehicles are regularly serviced and driven by experienced chauffeurs."
    },
    {
      "name": "Family Tempo Traveller Rental",
      "description": "Perfect for family trips, our Tempo Travellers provide spacious interiors, safety features, and driver services to ensure a stress-free travel experience for all ages."
    },
    {
      "name": "Wedding Tempo Traveller Pune",
      "description": "Make wedding transport easy and comfortable with our Tempo Traveller rentals. Ideal for shuttling guests between venues, pre-wedding functions, and post-wedding outings with style and punctuality."
    },
    {
      "name": "Corporate Tempo Hire",
      "description": "Professional Tempo Traveller services tailored for corporate needs including team outings, airport transfers, seminars, and conferences. Our punctual drivers and clean vehicles keep your corporate travel seamless."
    },
    {
      "name": "School Trip Tempo Rental",
      "description": "Safe and reliable Tempo Travellers for school trips with essential safety features, experienced drivers, and ample seating to accommodate students and teachers alike."
    },
    {
      "name": "Residential Tour Tempo Hire",
      "description": "Plan residential or community tours with our Tempo Traveller rentals. Comfortable seating and sufficient luggage space make group outings and neighborhood trips hassle-free."
    },
    {
      "name": "Long Route Tempo Traveller",
      "description": "Ideal for long-distance travel, these Tempo Travellers offer comfortable seating, air-conditioning (optional), and experienced drivers familiar with highway routes ensuring safe and relaxed journeys."
    },
    {
      "name": "Tempo with Driver in Pune",
      "description": "Hire a Tempo Traveller along with a professional driver who knows Pune and surrounding areas well. Our drivers maintain safety and assist with route planning and stops."
    },
    {
      "name": "Affordable Tempo Traveller Hire",
      "description": "Competitive pricing for Tempo Traveller rentals in Pune without compromising on vehicle quality or service standards. Perfect for budget trips and frequent travelers."
    },
    {
      "name": "Book Tempo Traveller Online Pune",
      "description": "Convenient online booking platform for Tempo Traveller rentals with instant confirmation, transparent pricing, and multiple payment options. Plan your trip with ease from home or office."
    }
  ],
  "tableData": [
    ["Pune Tempo Traveller Hire", "13/17 Seater Tempo Car Rental"],
    ["AC Tempo Traveller Pune", "Non AC Tempo Hire Pune"],
    ["Family Tempo Traveller Rental", "Wedding Tempo Traveller Pune"],
    ["Corporate Tempo Hire", "School Trip Tempo Rental"],
    ["Residential Tour Tempo Hire", "Long Route Tempo Traveller"],
    ["Tempo with Driver in Pune", "Affordable Tempo Traveller Hire"],
    ["Book Tempo Traveller Online Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Tempo Traveller On Rent in Pune",
    "WhyChoosedescription": "Vaishnavi Travels offers spacious and comfortable Tempo Travellers on rent in Pune, ideal for group travel, family outings, corporate trips, and tours."
  },
  {
    "WhyChooseheading": "Multiple Seating Options Available",
    "WhyChoosedescription": "Choose from 9, 12, 17, or 26-seater Tempo Travellers depending on your group size and travel needs."
  },
  {
    "WhyChooseheading": "Clean, Sanitized & Well-Maintained Vehicles",
    "WhyChoosedescription": "All our Tempo Travellers are regularly serviced and thoroughly cleaned to ensure a safe and hygienic ride."
  },
  {
    "WhyChooseheading": "Professional and Experienced Drivers",
    "WhyChoosedescription": "Our trained drivers are courteous, punctual, and familiar with both local and outstation routes for a smooth travel experience."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "Enjoy competitive rates with no hidden charges — pricing includes fuel, tolls, parking, and driver allowance."
  },
  {
    "WhyChooseheading": "Perfect for Local and Outstation Travel",
    "WhyChoosedescription": "Ideal for picnics, weddings, pilgrimages, office outings, airport transfers, and weekend getaways."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Available for hourly, daily, or multi-day rentals with customizable routes and pickup/drop locations."
  },
  {
    "WhyChooseheading": "24/7 Customer Support and Easy Booking",
    "WhyChoosedescription": "Our team is available round-the-clock to assist you with booking, itinerary planning, and travel queries."
  }
]











  }




const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels offer Tempo Traveller on rent in Pune?',
      answer: 'Yes, Vaishnavi Travels offers a wide range of Tempo Travellers on rent in Pune, ideal for group travel, family trips, corporate outings, and special events.',
    },
    {
      question: 'What seating options are available in the Tempo Traveller fleet?',
      answer: 'We provide Tempo Travellers in multiple seating capacities including 9, 12, 13, 17, and 20 seaters to cater to various group sizes and travel requirements.',
    },
    {
      question: 'What amenities are included in the Tempo Traveller rentals?',
      answer: 'Our Tempo Travellers are equipped with air-conditioning, push-back seats, ample legroom, luggage space, music system, and clean interiors for a comfortable travel experience.',
    },
    {
      question: 'Are drivers provided with the Tempo Traveller rental?',
      answer: 'Yes, all rentals include experienced and courteous drivers who are well-versed with local and outstation routes to ensure safe and smooth journeys.',
    },
    {
      question: 'What are the rental charges for Tempo Traveller in Pune?',
      answer: 'Tempo Traveller rental charges generally start from ₹4,500 for local use. Pricing may vary based on seating capacity, distance, duration, and travel route.',
    },
    {
      question: 'Can I hire a Tempo Traveller for outstation trips from Pune?',
      answer: 'Yes, Vaishnavi Travels offers Tempo Traveller services for both local and outstation trips including destinations like Mahabaleshwar, Lonavala, Goa, Shirdi, and more.',
    },
    {
      question: 'Is advance booking required for hiring a Tempo Traveller in Pune?',
      answer: 'It is recommended to book at least 2-3 days in advance, especially during weekends or peak travel seasons to ensure vehicle availability.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Ramesh Salunkhe",
    position: "Corporate Executive",
    feedback:
      "We hired a Tempo Traveller from Vaishnavi Travels for a team outing from Pune. The vehicle was clean, spacious, and the driver was extremely professional. Great service!",
    rating: 5,
  },
  {
    name: "Ms. Vaidehi Gokhale",
    position: "Tour Group Leader",
    feedback:
      "The Tempo Traveller rental from Vaishnavi Travels made our Mahabaleshwar trip very comfortable. Hassle-free booking and on-time service. Highly recommended!",
    rating: 5,
    style: "style-2",
  }
];








































































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tempo Traveller On Rent in Pune",
  "image": "https://vaishnavitravel.com/assets/images/tempo-traveller-rental-pune.jpg",
  "description": "Rent 13/17 seater AC and Non-AC Tempo Travellers in Pune for family trips, weddings, corporate events, school tours, and long routes with driver included.",
  "brand": {
    "@type": "Brand",
    "name": "Vaishnavi Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.6",
    "ratingCount": "140"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2500",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/tempo-traveller-on-rent-pune"
  }
};





  return (
    <div>
<Helmet>
  <title>Tempo Traveller On Rent in Pune | 13/17 Seater Tempo Hire</title>
  <meta
    name="description"
    content="Rent 13/17 seater AC and Non-AC Tempo Travellers in Pune for family trips, weddings, corporate events, school tours, and long routes with driver included."
  />
  <meta
    name="keywords"
    content="Pune Tempo Traveller Hire, 13/17 Seater Tempo Car Rental, AC Tempo Traveller Pune, Non AC Tempo Hire Pune, Family Tempo Traveller Rental, Wedding Tempo Traveller Pune, Corporate Tempo Hire, School Trip Tempo Rental, Residential Tour Tempo Hire, Long Route Tempo Traveller, Tempo with Driver in Pune, Affordable Tempo Traveller Hire, Book Tempo Traveller Online Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/55.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default TempoTravelleronrentinpune;